import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=49f56942&scoped=true&"
var script = {}
import style0 from "./Education.vue?vue&type=style&index=0&id=49f56942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f56942",
  null
  
)

export default component.exports